export default __webpack_public_path__ + "static/liner_flower-ad8b8523b0ee63265215d5a95eee929d.jpg";